// extracted by mini-css-extract-plugin
export default {"List":"_3HdnmNOgcT3JPtieghpjH_"};